module.exports = __webpack_public_path__ + "images/feature/20150520_project_stats_02-62e439fa2b95cf61277a84efa9348acf.png";